import { Component, inject } from '@angular/core';

import { DialogStore, IDialogItem } from '@shared/components/ui/dialog/data-access';
import { ModalComponent } from "@shared/components/ui/modal";
import { TextAlertComponent } from '@shared/components/ui/text-alert';
import { TranslateModule } from '@ngx-translate/core';
import { InputComponent } from '@shared/components/ui/input';
import { InputWrapperComponent } from '@shared/components/ui/input-wrapper';
import { SupportMessageComponent } from '@shared/components/ui/support-message';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'lib-dialog',
  imports: [ModalComponent, TextAlertComponent, TranslateModule, InputComponent, InputWrapperComponent, SupportMessageComponent, NgTemplateOutlet],
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.css',
})
export class DialogComponent {
  public readonly dialogStore = inject(DialogStore);

  public inputValueChange(value: string, dialog: IDialogItem): void {
    const input = dialog?.input;
    if (input) {
      input.value?.set(value);
      input.errorMessage?.set(null);
    }
  }

  public closeDialog(): void {
    this.dialogStore.closeDialog();
  }
}

